import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const items = ['Sei stanco di perdere ore tra Zanichelli, Pearson e YouTube.', 'Vuoi una programmazione professionale allineata al MIM.', 'Hai studenti con livelli diversi e non sai come differenziare.', 'Vuoi entrare in classe preparato e autorevole ogni giorno.'];
export function ForYouChecklist() {
  return <section className="py-10 sm:py-12 px-4 bg-brand-card/50 border-y border-brand-orange/10 relative" data-id="element-114">
      <div className="max-w-4xl mx-auto" data-id="element-115">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-10 uppercase text-brand-cream" data-id="element-116">
          È per te se...
        </motion.h2>

        <div className="space-y-4" data-id="element-117">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex gap-4 items-start bg-brand-dark p-5 rounded-xl border border-white/5 hover:border-brand-orange/30 transition-colors" data-id="element-118">
              <CheckCircle2Icon className="w-6 h-6 sm:w-8 sm:h-8 text-green-500 shrink-0 mt-0.5" data-id="element-119" />
              <p className="text-base sm:text-lg text-gray-200 font-medium leading-relaxed" data-id="element-120">
                {item}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}